import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';

import Button from 'ati-ui-react/components/Button/v3';
import { classes } from 'as-ui-kit/utils/styles';

import { useLocalized } from 'utils/useLocalized';
import { DataContext } from 'contexts';
import styles from './styles.modules.scss';
import i18nStrings from './strings';
import Tooltip from '@components/tooltip';
import {sendMetric} from 'utils/metrics';
import { useNavigate, useLocation } from 'react-router-dom';
import { PeriodType } from 'consts/consts';

const AccessPayment = ({isRow}) => {
    const strings = useLocalized(i18nStrings);
    const { isUser, isMobile, licenseInfo, processPay } = useContext(DataContext);
    const navigate = useNavigate();
    const location = useLocation();

    const isPayBtnHidden = isRow && !isUser;

    const payButtonJSX = (
        <Button
            filled
            className={classes(styles['pay-button'], isMobile && styles['full-screen'])}
            disabled={!licenseInfo.searchAccessPrices}
            theme="default"
            onClick={() => {
                !isPayBtnHidden && sendMetric('active-carriers-click-pay-for-access');
                processPay(navigate, location.search);
            }}
        >
            {isPayBtnHidden ? strings.showInfo : strings.pay}
        </Button>
    );

    return (
        <div className={classes(styles['pay-box'], (licenseInfo.searchAccessPrices && licenseInfo.searchAccessPrices[PeriodType.day]?.discount > 0 && styles['has-discount']))}>
            {licenseInfo.searchAccessPrices ? payButtonJSX : (
                <Tooltip
                    content={strings.payError}
                    maxWidth={230}
                >
                    {payButtonJSX}
                </Tooltip>
            )}
        </div>
    );
};

export default AccessPayment;

AccessPayment.propTypes = {
    isRow: PropTypes.bool
};
